import * as Sentry from "@sentry/react";
import { MutationCache, QueryCache, QueryClient, QueryKey } from "@tanstack/react-query";
import axios from "axios";

// HTTP responses (4xx = expected business errors, 5xx = already captured by the backend)
// and cancelled requests are not reported; only network failures and client-side bugs are.
const shouldReportToSentry = (error: unknown) => {
  if (axios.isCancel(error)) return false;
  if (axios.isAxiosError(error)) return !error.response;
  return true;
};

const formatKey = (key: QueryKey | undefined) => (key ? JSON.stringify(key) : undefined);

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (!shouldReportToSentry(error)) return;
      Sentry.captureException(error, {
        tags: { source: "react-query", type: "query" },
        extra: { queryKey: formatKey(query.queryKey) },
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (!shouldReportToSentry(error)) return;
      Sentry.captureException(error, {
        tags: { source: "react-query", type: "mutation" },
        extra: { mutationKey: formatKey(mutation.options.mutationKey) },
      });
    },
  }),
});
